import { getText } from "../strings";

export function validateNonEmptyString(input: string): string | undefined {
  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return getText("validation-input-empty");
  }
  return;
}
